// extracted by mini-css-extract-plugin
module.exports = {"wgafshb":"wgafshb"};